export default __webpack_public_path__ + "static/media/notification.f424cb99.svg";